import * as React from "react";
import { forwardRef } from "react";
const SvgTelephoneHangupBase = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M49.357 45.517c11.78-.069 23.575 1.54 35.375 4.833l.596 1.13a14.3 14.3 0 0 1 6.266 4.227 14.28 14.28 0 0 1-.231 18.777c-8.789-2.773-16.957-4.698-24.35-5.588a14.28 14.28 0 0 1 1.248-10.822c-12.16-1.633-23.944-2.169-37.04-.863a14.28 14.28 0 0 1 1.762 11.694c-9.118 1.337-17.3 3.158-24.34 5.58A14.28 14.28 0 0 1 6.187 59.26a14.28 14.28 0 0 1 7.155-7.245l.713-1.228c11.76-3.438 23.524-5.196 35.304-5.268z" />
  </svg>
);
const ForwardRef = forwardRef(SvgTelephoneHangupBase);
export default ForwardRef;
